import Rollbar from 'rollbar';
import rollbarIgnoredErrors from '@/rollbarIgnoredErrors.js';

const rollbarEnabled = () => {
  return import.meta.env.VITE_FORCE_ROLLBAR || window.config.env == import.meta.env.VITE_ENV;
};

const rollbarRun = (e) => {
  if (!rollbarEnabled()) return;
  const rollbar = new Rollbar({
    accessToken: import.meta.env.VITE_ROLLBAR_TOKEN,
    captureUncaught: true,
    captureUnhandledRejections: true,
    environment: import.meta.env.VITE_ENV,
    payload: {
      client: {
        javascript: {
          source_map_enabled: true,
        },
      },
    },
    checkIgnore: function (isUncaught, args, payload) {
      const message = payload?.body?.trace?.exception?.message ?? payload?.body?.trace_chain?.[0]?.exception?.message ?? '';
      return rollbarIgnoredErrors.some((entry) => message.includes(entry.message));
    },
  });
  rollbar.error(e);
};

const errorManager = (e) => {
  console.error(e);
  rollbarRun(e);
};

export default errorManager;
